/*
 *
 * Notifier actions
 *
 */
import uniqid from 'uniqid';
import { ENQUEUE_SNACKBAR, CLOSE_SNACKBAR, REMOVE_SNACKBAR } from './constants';

/**
 * @dev - enqueueSnackbar a custom action for handling snackbar
 * for more options props details check the link below
 * https://iamhosseindhv.com/notistack/api#enqueuesnackbar-options
 *
 * @param {string} message - text message to displays
 * @param {object} options - test message to displays
 */
export const enqueueSnackbar = notification => {
  const key = notification.options && notification.options.key;

  return {
    type: ENQUEUE_SNACKBAR,
    notification: {
      ...notification,
      key: key || uniqid(),
    },
  };
};

export const closeSnackbar = key => {
  return {
    type: CLOSE_SNACKBAR,
    dismissAll: !key, // dismiss all if no key has been defined
    key,
  };
};

export const removeSnackbar = key => ({
  type: REMOVE_SNACKBAR,
  payload: {
    key,
  },
});
